import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJAIVideoEffect from '../view/FJAIVideoEffect.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setVideoEffectStyleSelectId } from '../../../../redux/slices/FJSliceAIVideoGenerator.js';
import { VIDEO_EFFECT_STYLE_LIST } from '../../../../config/dataConfig/FJVideoEffectData.js';

const FJAIVideoEffectContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const videoEffectStyleSelectId = useSelector(state => state.AIVideoGenerator.videoEffectStyleSelectId);

    const _onChooseStyle = id => {
        dispatch(setVideoEffectStyleSelectId(id));
    };

    return (
        <FJAIVideoEffect
            videoEffectStyleSelectId={videoEffectStyleSelectId}
            onChooseStyle={_onChooseStyle}
            list={VIDEO_EFFECT_STYLE_LIST}
        />
    );
};

export default FJAIVideoEffectContainer;
